import { render, staticRenderFns } from "./BackOnTop.vue?vue&type=template&id=fe9f0d0e&scoped=true&"
import script from "./BackOnTop.vue?vue&type=script&lang=js&"
export * from "./BackOnTop.vue?vue&type=script&lang=js&"
import style0 from "./BackOnTop.vue?vue&type=style&index=0&id=fe9f0d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9f0d0e",
  null
  
)

export default component.exports